import { useState } from 'react';

const STORAGE_KEY = 'pmai.collapsedSections';

function read(): Set<string> {
  try {
    return new Set(JSON.parse(localStorage.getItem(STORAGE_KEY) ?? '[]') as string[]);
  } catch {
    return new Set();
  }
}

/**
 * Open/closed state of a card section, kept in this browser and shared by every card of the same
 * kind (FR-PRJ-016) — `id` names the section, not the record.
 */
export function useCollapsed(id: string): [open: boolean, toggle: () => void] {
  const [collapsed, setCollapsed] = useState(() => read().has(id));
  const toggle = () => {
    const all = read();
    if (collapsed) all.delete(id);
    else all.add(id);
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify([...all]));
    } catch {
      // storage unavailable — the state still toggles for this visit
    }
    setCollapsed(!collapsed);
  };
  return [!collapsed, toggle];
}
